module.exports = __webpack_public_path__ + "img/regolestorie05.b9635298.png";